export default __webpack_public_path__ + "static/media/login.085e7538.png";